<template lang="pug">
  .pagination
    .pagination__button
      a.pag-link(
      :class="{'pag-link_disabled' : disabledButtonPrev}"
      @click.prevent="onButtonClick(currentPage - 1)"
      )
        img(src="@/assets/images/icons/pag-prev.svg")
    ul.pagination__list
      li.pagination__item
        a.pag-link(
        :class="{'pag-link_active' : currentPage === 1}"
        @click.prevent="onButtonClick(1)"
        ) 1
      li.pagination__item(
      v-if="showFirstEmptyButton"
      )
        .pag-link.pag-link_empty
      li.pagination__item(
      v-for="item in middlePagesList"
      )
        a.pag-link(
        :class="{'pag-link_active' : currentPage === item}"
        @click.prevent="onButtonClick(item)"
        ) {{item}}
      li.pagination__item(
        v-if="showLastEmptyButton"
      )
        .pag-link.pag-link_empty
      li.pagination__item(
      v-if="pagesList.length > 1"
      )
        a.pag-link(
        :class="{'pag-link_active' : currentPage === pagesList.length}"
        @click.prevent="onButtonClick(pagesList.length)"
        ) {{pagesList.length}}
    .pagination__button
      a.pag-link(
      :class="{'pag-link_disabled' : disabledButtonNext}"
      @click.prevent="onButtonClick(currentPage + 1)"
      )
        img(src="@/assets/images/icons/pag-next.svg")
</template>

<script>
export default {
  name: "Pagination",
  props: {
    totalCount: {
      type: Number,
      default: 0
    },
    pageLimit: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  computed: {
    pagesList() {
      const arr = [];
      const pagesCount = Math.ceil(this.totalCount / this.pageLimit);
      for (let i = 1; i <= pagesCount; i++) {
        arr.push(i);
      }
      return arr;
    },
    disabledButtonPrev() {
      return this.currentPage === this.pagesList[0];
    },
    disabledButtonNext() {
      return this.currentPage === this.pagesList[this.pagesList.length - 1];
    }
  },
  data() {
    return {
      showFirstEmptyButton: false,
      showLastEmptyButton: false,
      middlePagesList: []
    };
  },
  methods: {
    setButtons() {
      const arr = this.pagesList.slice(1, this.pagesList.length - 1);
      if (arr.length > 5) {
        if (this.currentPage <= 4) {
          this.middlePagesList = arr.slice(0, 4);
          this.showFirstEmptyButton = false;
          this.showLastEmptyButton = true;
          return;
        }
        if (this.currentPage >= this.pagesList.length - 3) {
          this.middlePagesList = arr.slice(arr.length - 4, arr.length + 1);
          this.showFirstEmptyButton = true;
          this.showLastEmptyButton = false;
          return;
        }
        this.middlePagesList = arr.slice(arr.indexOf(this.currentPage) - 1, arr.indexOf(this.currentPage) + 2);
        this.showFirstEmptyButton = true;
        this.showLastEmptyButton = true;
        return;
      }
      this.middlePagesList = arr;
    },
    onButtonClick(button) {
      this.$emit("on-button-click", button);
    }
  },
  created() {
    this.setButtons();
  },
  watch: {
    pagesList() {
      this.setButtons();
    },
    currentPage() {
      this.setButtons();
    }

  }
};
</script>
